import { ethers } from "ethers";
import { Chain } from "../components/data";

export const audioElement = new Audio('');
declare let WeixinJSBridge: any

function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
    });
}
export const setWechatFont = () => {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if ((document as any).attachEvent) {
            (document as any).attachEvent("WeixinJSBridgeReady", handleFontSize);
            (document as any).attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
    }
}

export const emptyEthAddress = '0x0000000000000000000000000000000000000000';
export const emptyTronAddress = 'TR00000000000000000000000000000000';

function numberToDecimalString(amount: number | string) {
    const raw = typeof amount === 'number' ? String(amount) : amount.trim();
    if (raw === '') return '0';
    if (!/[eE]/.test(raw)) return raw;

    const [coefficient, exponentText] = raw.toLowerCase().split('e');
    const exponent = Number(exponentText);
    if (!Number.isFinite(exponent)) return '0';

    const sign = coefficient.startsWith('-') ? '-' : '';
    const unsigned = coefficient.replace('-', '');
    const [integerPart, fractionPart = ''] = unsigned.split('.');
    const digits = integerPart + fractionPart;
    const decimalIndex = integerPart.length + exponent;

    if (decimalIndex <= 0) {
        return sign + '0.' + '0'.repeat(Math.abs(decimalIndex)) + digits;
    }
    if (decimalIndex >= digits.length) {
        return sign + digits + '0'.repeat(decimalIndex - digits.length);
    }
    return sign + digits.slice(0, decimalIndex) + '.' + digits.slice(decimalIndex);
}

function trimToDecimals(value: string, decimal: number) {
    const [integerPart, fractionPart = ''] = value.split('.');
    if (!fractionPart) return integerPart;
    return integerPart + '.' + fractionPart.slice(0, decimal);
}

export function parseAmount(amount: number | string, decimal: number): string {
    if (amount === '' || Number.isNaN(Number(amount))) {
        return '0';
    }
    return ethers.parseUnits(trimToDecimals(numberToDecimalString(amount), decimal), decimal).toString();
}

export function specifyGasLimit(chain: Chain): string {
    return '400000';
}

export function sleep(millis: number) {
    return new Promise(resolve => setTimeout(resolve, millis));
}

export const convertBitcoinNum = (sats: number) => {
    return (sats / 100000000).toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 })
}